// Piezas compartidas (componentes/), el editor del reel (montaje/editor.tsx) y los avisos de subidas.ts.
export default {
  // componentes/emblema.tsx
  'Logo de {nombre}': '{nombre} logo',
  // componentes/piezas.tsx
  Copiar: 'Copy',
  'Copiar {que}': 'Copy {que}',
  Copiado: 'Copied',
  texto: 'text',
  'texto de LinkedIn': 'LinkedIn text',
  hashtags: 'hashtags',
  todo: 'all',
  'Por confirmar': 'Please double-check',
  // componentes/tablero.tsx
  Anteriores: 'Previous',
  Siguientes: 'Next',
  Reparto: 'Breakdown',
  'Ver más': 'Show more',
  'Ver menos': 'Show less',
  // subidas.ts
  'No pudimos subir {archivo}.': "We couldn't upload {archivo}.",
  // montaje/editor.tsx
  'Este navegador no puede preparar el video. Ábrelo en Chrome desde un computador, o descárgalo sin edición.':
    "This browser can't prepare the video. Open it in Chrome on a computer, or download it unedited.",
  'No pudimos preparar el video editado. Vuelve a intentarlo o descárgalo sin edición.':
    "We couldn't prepare the edited video. Try again or download it unedited.",
  Ritmo: 'Pace',
  'Más rápido': 'Faster',
  'Sin pausas': 'No pauses',
  Efectos: 'Effects',
  Color: 'Color',
  Original: 'Original',
  'Encima del video': 'On top of the video',
  Subtítulos: 'Subtitles',
  'Textos en pantalla': 'On-screen text',
  Logo: 'Logo',
  'Descargar video': 'Download video',
  'Acomodando los textos…': 'Placing the text…',
  'Preparando… {porcentaje}%': 'Preparing… {porcentaje}%',
  Cancelar: 'Cancel',
  'Descargar sin edición': 'Download unedited',
  'Se prepara en tu navegador: no cierres esta pestaña.': "It's being prepared in your browser: don't close this tab.",
  // Nombres de color de montaje/recursos.json
  Cálido: 'Warm',
  Fresco: 'Fresh',
  Vivo: 'Vivid',
  'Ámbar suave': 'Soft amber',
  'Blanco y negro': 'Black & white',
  Durazno: 'Peach',
  'Noche cálida': 'Warm night',
  'Rosa pop': 'Pop pink',
  "Listo: {paso}": "Ready: {paso}",
  "Entra a IGOR para verlo.": "Open IGOR to see it.",
  "Tu video te espera": "Your video is waiting for you",
  "Para el equipo:": "For the team:",
  "sin saldo": "no balance",
  "Recarga para que los videos y las imágenes no fallen.": "Top up so videos and images don't fail.",
} satisfies Record<string, string>;
